module.exports = __webpack_public_path__ + "img/icon-female.7b9ce4a7.png";